import React, { useEffect, useState, useContext } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import UserContext from "../context/UserContext";
import FundStripe from "./FundStripe";
import { api } from "../utils/apiHelper";
import "../styles/Fundraiser.css";

const stripePromise = loadStripe("pk_live_51Rce3SAiBftvH423MIGBNy4l080OCs812VSiItIzcy2zZAc5zxBFcuU8fcp9Y0uJumOMygGwkaxnmKV4aTbHaeh200Gp46JiDc");

const Fundraiser = () => {
  const { authUser } = useContext(UserContext);
  const [popCustom, setPopCustom] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(true);

   const images = {
    liveAction: "live action.png",
    marquee: "live action lights.png"
  };


  useEffect(() => {
    const fetchPopCustom = async () => {
      try {
        const res = await api("/get-active-popcustom", "GET");
        if (res?.activePopCustom) {
          setPopCustom(res.activePopCustom);
        }
      } catch (err) {
        console.error("Error fetching active PopCustom:", err);
      }
    };

    fetchPopCustom();
  }, []);

  return (
    <div className="fundraiser-container">
      <h1 className="member"></h1>

  {popCustom && (
        <div className="fundraiser-popcustom">
          <h1 style={{ fontFamily: popCustom.headerStyle || "inherit" }}>
            {popCustom.header}
          </h1>

          <div style={{ fontFamily: popCustom.paragraph?.style || "inherit" }}>
            <p>
              {isCollapsed
                ? `${popCustom.paragraph?.text.slice(0, 100)}...`
                : popCustom.paragraph?.text}
            </p>
            <button
              className="toggle-button"
              onClick={() => setIsCollapsed(!isCollapsed)}
            >
              {isCollapsed ? "Read More" : "Show Less"}
            </button>

          </div>
           <div className="fundraiser-payment">
            <Elements stripe={stripePromise}>
              <FundStripe authUser={authUser} />
            </Elements>
          </div>

             <img
                src={popCustom.imageUrl}
                alt={popCustom.header}
                className="fundraiser-popcustom-image"
              />

        </div>
      )}
    </div>
  );
};

export default Fundraiser;
